// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: bZD6nV99rCXf
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicPaymentVoided.module.css"; // plasmic-import: bZD6nV99rCXf/css
import Icon7Icon from "./icons/PlasmicIcon__Icon7"; // plasmic-import: hcK0vMCAdLKs/icon

createPlasmicElementProxy;

export const PlasmicPaymentVoided__VariantProps = new Array();

export const PlasmicPaymentVoided__ArgProps = new Array("date");

const $$ = {};

function PlasmicPaymentVoided__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__ozU8P)}>
              <div
                data-plasmic-name={"rectangle28"}
                data-plasmic-override={overrides.rectangle28}
                className={classNames(projectcss.all, sty.rectangle28)}
              >
                <div
                  className={classNames(projectcss.all, sty.freeBox___6VyCs)}
                >
                  <div
                    data-plasmic-name={"text"}
                    data-plasmic-override={overrides.text}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text
                    )}
                  >
                    {"Payment Voided"}
                  </div>
                  <Icon7Icon
                    data-plasmic-name={"svg"}
                    data-plasmic-override={overrides.svg}
                    className={classNames(projectcss.all, sty.svg)}
                    role={"img"}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__fYYqK)}>
                  {renderPlasmicSlot({
                    defaultContents: "On July 12, 2022",
                    value: args.date,
                    className: classNames(sty.slotTargetDate)
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: ["root", "previewBody", "rectangle28", "text", "svg"],
  previewBody: ["previewBody", "rectangle28", "text", "svg"],
  rectangle28: ["rectangle28", "text", "svg"],
  text: ["text"],
  svg: ["svg"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPaymentVoided__ArgProps,
          internalVariantPropNames: PlasmicPaymentVoided__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPaymentVoided__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPaymentVoided";
  } else {
    func.displayName = `PlasmicPaymentVoided.${nodeName}`;
  }
  return func;
}

export const PlasmicPaymentVoided = Object.assign(
  // Top-level PlasmicPaymentVoided renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    previewBody: makeNodeComponent("previewBody"),
    rectangle28: makeNodeComponent("rectangle28"),
    text: makeNodeComponent("text"),
    svg: makeNodeComponent("svg"),
    // Metadata about props expected for PlasmicPaymentVoided
    internalVariantProps: PlasmicPaymentVoided__VariantProps,
    internalArgProps: PlasmicPaymentVoided__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicPaymentVoided;
/* prettier-ignore-end */
